<template>
    <section v-if="getFilters && getFilters.data && getFilters.data.length && hasValidRefineLinks">
        <div class="grid xs-grid-cols-1">
            <h2 class="f4 text-bold">Refine your search for houses in {{getFilters.demographicName}}</h2>
              <div class='grid gap-3 fixed xs-grid-cols-1 sm-grid-cols-4'>
                <template v-for='filter in getFilters.data' :key='filter.title'>
                    <div v-if="filter.items && filter.items.length" :class="filter.title.toLowerCase()">
                        <div class="f5 text-bold m-b-1 text-bold">{{ filter.title }}</div>
                        <ul>
                            <li v-for="(item, index) in filter.items" :key="index">
                                <a class="link grid gap-0 xs-grid-cols-2 sm-grid-cols-1 md-grid-cols-1" @click="track(item.text)" :href="item.url" :title="item.text">
                                    <span>{{item.text}}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </template>
            </div>
        </div>
    </section>
</template>

<script src="./search-filteredmsplinks.js"></script>

<style lang="scss">
.amenities, .price, .bedrooms, .bathrooms {
   li a span {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow-x: hidden;
   }
}
</style>
